import React from 'react';
import Dialog from '../Dialog';
import Table from 'Components/Core/Table';
import './DialogSelectText.css';

export default function DialogSelectText(props) {

    const x = props.x;

	const [loadTable, setLoadTable] = React.useState(0);
	const data = React.useRef([]);
	
	const id = props.id + '-dialog';
	const wafId = (typeof props.wafId === 'undefined') ? 'dialog-select-text' : props.wafId

	x.wad.init(id);
	x.wad[id].showSelection = showSelection;
	x.waf.init(wafId);
	x.waf[wafId][id] = {};

	React.useEffect(() => {
		const setData = async () => {
			// data.current = await getData();
		}
		setData();
		setLoadTable(1);
	}, [props, x]);

	async function showSelection() {
		const setData = async () => {
			return await getData();
		}
		data.current = await setData();
		const reRenderTable = Date.now();
		setLoadTable(reRenderTable);
		x.wad[id].show();
	}

	function select(selectId, selectName) {
		if (selectId === '__divider__') {
			return;
		}
		x.wad[id].hide();
		x.wad[id].setValue(selectId, selectName);
	}

	async function getData() {
		const data = (typeof props.onSetData !== 'undefined') ? await props.onSetData() : [];

		return data;
	}

	return (
		<Dialog id={id} x={x}   classes={`dialog-get-text ${props.classes}`} title={props.title} >
			<Table
				id={props.id}
				x={x}
				dialogId={id}
				loadTable={loadTable}
				classes={` `} 
				noTitle={false}
				onAddColumn={(typeof props.onAddColumn === 'undefined') ? (key, value) => {
					switch (key) {
						case 'name':
							return value;
						default:
							return false;
					}
				} : props.onAddColumn}
				onRowClasses={props.onRowClasses}
				onLoad={
					() => {
						return data.current;
					}
				}
				onRowEdit={(e, rowFields) => { 
					e.preventDefault();
					select(rowFields.id, rowFields.name); 
				}}
			/>
		</Dialog>
	)
};
